// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Tap$Showside from "./Tap.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Location$Showside from "./Location.bs.js";
import * as WebapiUtils$Showside from "./WebapiUtils.bs.js";
import * as HistoryUtils$Showside from "./HistoryUtils.bs.js";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as BrowserNavigation$Showside from "./BrowserNavigation.bs.js";
import * as ScrollRestoration$Showside from "./ScrollRestoration.bs.js";
import * as RefByQuerySelector$Showside from "./RefByQuerySelector.bs.js";
HistoryUtils$Showside.setScrollRestoration("manual");
var blockingOnScrollEvent = {
  contents: false
};
function setBlockingOnScrollEvent(bool) {
  blockingOnScrollEvent.contents = bool;
}
function isBlockingOnScrollEvent(param) {
  return blockingOnScrollEvent.contents;
}
function useScrollHeightObserver(fn) {
  var match = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var $$clearTimeout = match.clearTimeout;
  var $$setTimeout = match.setTimeout;
  var lastScrollHeightRef = React.useRef(0);
  var ref = RefByQuerySelector$Showside.use(undefined, "body");
  var loop = function (param) {
    $$setTimeout(function (param) {
      var el = ref.current;
      if (!(el == null) && el.scrollHeight !== lastScrollHeightRef.current) {
        Curry._1(fn, undefined);
        lastScrollHeightRef.current = el.scrollHeight;
      }
      Curry._1($$clearTimeout, undefined);
      loop(undefined);
    }, 100);
  };
  React.useEffect(function () {
    loop(undefined);
  }, []);
}
function useDisableOverflowAnchor(param) {
  var id = "smartnav-overflow-anchor-style";
  React.useEffect(function () {
    var style = document.getElementById(id);
    if (style == null) {
      var arg = document.createTextNode("body { overflow-anchor: none; }");
      var arg$1 = Tap$Showside.tap(Tap$Showside.tap(document.createElement("style"), function (__x) {
        __x.setAttribute("id", id);
      }), function (param) {
        param.appendChild(arg);
      });
      Belt_Option.forEach(WebapiUtils$Showside.$$Document.body(document), function (param) {
        param.appendChild(arg$1);
      });
    }
    return function (param) {
      var style = document.getElementById(id);
      if (!(style == null)) {
        style.remove();
        return;
      }
    };
  }, []);
}
function useGlobalScrollRestoration(idOpt, offset, embedHeight, param) {
  var id = idOpt !== undefined ? idOpt : "global";
  useDisableOverflowAnchor(undefined);
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  var timeout1 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var timeout2 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var isOverlay = function (param) {
    if (Belt_Option.isSome(Location$Showside.getStatesByNamespace(namespace).current.quickView.mediaId)) {
      return true;
    } else {
      return Belt_Option.mapWithDefault(Location$Showside.getStatesByNamespace(namespace).current.quickNav, false, function (loc) {
        return Belt_Option.isSome(loc.productId);
      });
    }
  };
  var offsetRef = React.useRef(0);
  var previousScroll = React.useRef(0);
  var updatePreviousScroll = function (scrollY) {
    var willUpdate = !isOverlay(undefined) && !isBlockingOnScrollEvent(undefined);
    previousScroll.current = willUpdate ? scrollY : previousScroll.current;
  };
  var getCurrentKey = function (param) {
    return Location$Showside.toQueryString(undefined, Location$Showside.sanitizeLocation(Location$Showside.getStatesByNamespace(namespace).current));
  };
  var getSavedScrollY = function (localStorageOpt, offset) {
    var localStorage = localStorageOpt !== undefined ? localStorageOpt : false;
    var match = ScrollRestoration$Showside.getScroll(namespace, localStorage, id);
    var match$1 = !isOverlay(undefined);
    if (typeof match !== "number" && match.TAG === /* Pixels */0) {
      if (match$1 && previousScroll.current >= offset) {
        return Math.max(match._0, offset);
      } else {
        return;
      }
    }
    if (match$1 && previousScroll.current >= offset) {
      return ScrollRestoration$Showside.getClosestBreakingPoint(previousScroll.current, offset);
    }
  };
  var scrollTo = function (y) {
    window.scrollTo(0.0, y);
  };
  var applyScroll = function (param) {
    var savedScrollY = getSavedScrollY(undefined, offsetRef.current);
    var currentScrollY = Tap$Showside.tap(Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
    if (savedScrollY !== undefined && savedScrollY !== currentScrollY) {
      return scrollTo(savedScrollY);
    }
  };
  var lastKey = React.useRef(getCurrentKey(undefined));
  useScrollHeightObserver(function (param) {
    if (isBlockingOnScrollEvent(undefined)) {
      return applyScroll(undefined);
    }
  });
  var applyOnLocationChange = function (offset) {
    offsetRef.current = offset;
    var apply = function (param) {
      var currentKey = getCurrentKey(undefined);
      var savedScrollY = getSavedScrollY(undefined, offset);
      if (savedScrollY !== undefined && lastKey.current !== currentKey) {
        setBlockingOnScrollEvent(true);
        scrollTo(savedScrollY);
        timeout1.setTimeout(function (param) {
          applyScroll(undefined);
          timeout2.setTimeout(function (param) {
            setBlockingOnScrollEvent(false);
          }, 100);
        }, 0);
      }
      lastKey.current = currentKey;
    };
    var removePreviousCallback = function (param) {
      Location$Showside.setLocalCallbacksByNamespace(namespace, Belt_Array.keep(Location$Showside.getStatesByNamespace(namespace).localCallbacks, function (fn) {
        return fn !== apply;
      }));
    };
    var addCallback = function (param) {
      Location$Showside.setLocalCallbacksByNamespace(namespace, Belt_Array.concat(Location$Showside.getStatesByNamespace(namespace).localCallbacks, [apply]));
    };
    removePreviousCallback(undefined);
    addCallback(undefined);
    return function (param) {
      removePreviousCallback(undefined);
    };
  };
  var saveOnScroll = function (offset) {
    var save = function (param) {
      var currentScroll = Tap$Showside.tap(Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
      if (isBlockingOnScrollEvent(undefined)) {
        return ScrollRestoration$Showside.ScrollRestorationLocalStorage.set(id, {
          TAG: /* Pixels */0,
          _0: offset
        });
      } else {
        return ScrollRestoration$Showside.setCurrentScroll(namespace, id, {
          TAG: /* Pixels */0,
          _0: currentScroll
        });
      }
    };
    var removePreviousListener = function (param) {
      window.removeEventListener("scroll", save, {
        capture: false,
        passive: true
      });
    };
    var addListener = function (param) {
      window.addEventListener("scroll", save, {
        capture: false,
        passive: true,
        once: false
      });
    };
    removePreviousListener(undefined);
    addListener(undefined);
    return removePreviousListener;
  };
  var cachedCleanupFns = React.useRef({});
  var runSparingly = function (fn) {
    var fnName = fn.name;
    var isInitialized = function (param) {
      return Belt_Option.isSome(Js_dict.get(cachedCleanupFns.current, fnName));
    };
    var initialize = function (cleanupFn) {
      cachedCleanupFns.current = Js_dict.fromArray(Belt_Array.concat(Js_dict.entries(cachedCleanupFns.current), [[fnName, cleanupFn]]));
    };
    if (offset !== undefined && !isInitialized(undefined)) {
      initialize(Curry._1(fn, offset));
    }
  };
  var cleanUp = function (param) {
    Belt_Array.forEach(Belt_Array.keepMap(Js_dict.values(cachedCleanupFns.current), function (v) {
      return v;
    }), function (cleanUp) {
      Curry._1(cleanUp, undefined);
    });
  };
  React.useEffect(function () {
    return runSparingly(saveOnScroll);
  }, [offset]);
  React.useEffect(function () {
    return runSparingly(applyOnLocationChange);
  }, [offset]);
  React.useEffect(function () {
    return cleanUp;
  }, []);
  BrowserNavigation$Showside.useBrowserNavigation(function (navigationType) {
    var offset$1 = Belt_Option.getWithDefault(offset, 0);
    var embedHeight$1 = Belt_Option.getWithDefault(embedHeight, 0);
    var totalEmbedHeight = offset$1 + embedHeight$1 | 0;
    var px = ScrollRestoration$Showside.getScroll(namespace, true, id);
    var pxToScroll;
    pxToScroll = typeof px === "number" || px.TAG !== /* Pixels */0 ? undefined : px._0;
    if (navigationType !== 1) {
      return ScrollRestoration$Showside.ScrollRestorationLocalStorage.$$delete(id);
    } else if (pxToScroll !== undefined && pxToScroll > (Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined) | 0) && pxToScroll < totalEmbedHeight) {
      return scrollTo(pxToScroll);
    } else {
      return;
    }
  }, [offset, embedHeight]);
}
export { setBlockingOnScrollEvent, isBlockingOnScrollEvent, useScrollHeightObserver, useDisableOverflowAnchor, useGlobalScrollRestoration };
/*  Not a pure module */